import { useTranslation } from 'react-i18next';
import { Card } from '@/common/components/Card/Card';
import { Grid } from '@/common/components/Grid/Grid';
import { Heading } from '@/common/components/Heading/Heading';
import { IconBadge } from '@/common/components/IconBadge/IconBadge';
import { Icon } from '@/common/components/Icons/Icon';
import { LabeledValue } from '@/common/components/LabeledValue/LabeledValue';
import { Stack } from '@/common/components/Stack/Stack';
import { ROUTES } from '@/common/constants/routes';
import { IInsurancePolicy } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { useRouter } from 'expo-router';

export type THomeInsuranceCardProps = {
  policy: IInsurancePolicy;
};

export function HomeInsuranceCard({ policy }: THomeInsuranceCardProps) {
  const router = useRouter();
  const { t } = useTranslation();

  const cardNumber = policy?.persons.find(
    (p) => p.type === 'employee'
  )?.cardNumber;

  return (
    <Card onPress={() => router.navigate(ROUTES.INSURANCE)}>
      <Stack justify="between" gap="md">
        <Stack horizontal align="center" justify="between" gap="md">
          <Heading level={4}>
            {t('wallet.insurance.cards.health.title')}
          </Heading>
          <IconBadge
            icon={<Icon icon="shield-plus" />}
            backgroundColor="accentSecondary20"
            ratio={32}
          />
        </Stack>
        <Grid columnBasis="basis-[20rem]" columnGap="md" rowGap="md">
          <LabeledValue
            label={t('dashboard.insurance.card.insurance_company')}
            value={policy.product.provider.name}
          />
          <LabeledValue
            label={t('dashboard.insurance.card.policy_number')}
            value={policy.policyNumber}
          />
          {cardNumber ? (
            <LabeledValue
              label={t('dashboard.insurance.card_number')}
              value={cardNumber}
            />
          ) : null}
        </Grid>
      </Stack>
    </Card>
  );
}
